import { usePaginatedQuery } from '../../../hooks/use-paginated-query';
import type { CustomerSearchQuery } from '../types/api';
import type { Customer } from '../types/customer';
import { useCustomersApi } from './use-customers-api';

const QK_SEARCH_CUSTOMERS = (query: CustomerSearchQuery) => ['customers', query] as const;

export function useSearchCustomers(query: CustomerSearchQuery, options?: { pageSize?: number }) {
  const { customersApi } = useCustomersApi();

  return usePaginatedQuery<Customer, CustomerSearchQuery>(query, {
    queryKey: QK_SEARCH_CUSTOMERS(query),
    queryFn: (args, paginationOpts) => customersApi.search(args, paginationOpts),
    pageSize: options?.pageSize,
  });
}
